import React from 'react';

export default function CastList({ heading, castText }) {
  const lang = localStorage.getItem('language') || 'arm';
  const headingStr = heading ? (heading[lang] || heading.en || '') : '';
  const castStr    = castText ? (castText[lang] || castText.en || '') : '';

  if (!castStr) return null;

  return (
    <section className='cast-list-section'>
      {headingStr && <h3 className='cast-heading'>{headingStr}</h3>}
      <pre className='cast-text' style={{ whiteSpace: 'pre-wrap', fontFamily: 'inherit' }}>
        {castStr}
      </pre>
    </section>
  );
}
